var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotfound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 187,
    viewBox: "0 0 265 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1395_10005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.314453 -0.212891H264.691V187.212H0.314453V-0.212891Z",
    fill: "#B29BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.314453 -0.212891H264.691V25.8481H0.314453V-0.212891Z",
    fill: "#D2C3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.687 -0.212891V187.212H0.314453",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4274 123.271H78.7035V138.387H62.46V123.271H23.6934V112.065L57.6084 66.4082H75.1014L43.6425 109.698H62.9741V96.2284H78.7035V109.698H90.4274V123.271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3711 102.397C95.3711 78.6454 108.53 65.1758 126.219 65.1758C144.005 65.1758 157.064 78.6454 157.064 102.397C157.064 126.148 144.005 139.621 126.219 139.621C108.519 139.621 95.3711 126.151 95.3711 102.397ZM140.303 102.397C140.303 86.0496 134.548 79.263 126.219 79.263C117.991 79.263 112.232 86.046 112.232 102.397C112.232 118.747 117.991 125.534 126.219 125.534C134.538 125.534 140.292 118.747 140.292 102.397H140.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.086 123.271H219.365V138.387H203.118V123.271H164.352V112.065L198.267 66.4082H215.76L184.301 109.698H203.632V96.2284H219.365V109.698H231.086V123.271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.46 123.271H23.6934M90.4274 109.705V123.271H78.7035V138.387H62.46M78.7035 96.2284V109.698M75.1049 66.4082L43.6425 109.698H62.9741",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.125 70.2129C151.693 76.1462 157.048 87.1525 157.048 102.396C157.048 126.151 143.989 139.621 126.203 139.621M114.094 115.895C116.432 122.585 120.78 125.534 126.203 125.534C134.532 125.534 140.287 118.751 140.287 102.396C140.287 86.0423 134.532 79.2628 126.203 79.2628",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.086 109.698V123.264H219.365V138.379H203.118M219.365 96.2213V109.691M215.767 66.4082L184.301 109.698H203.632",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.535 17.0239C20.964 17.0239 22.9332 15.1634 22.9332 12.8684C22.9332 10.5734 20.964 8.71289 18.535 8.71289C16.1059 8.71289 14.1367 10.5734 14.1367 12.8684C14.1367 15.1634 16.1059 17.0239 18.535 17.0239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1131 17.0239C37.5422 17.0239 39.5113 15.1634 39.5113 12.8684C39.5113 10.5734 37.5422 8.71289 35.1131 8.71289C32.684 8.71289 30.7148 10.5734 30.7148 12.8684C30.7148 15.1634 32.684 17.0239 35.1131 17.0239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6932 17.0239C54.1222 17.0239 56.0914 15.1634 56.0914 12.8684C56.0914 10.5734 54.1222 8.71289 51.6932 8.71289C49.2641 8.71289 47.2949 10.5734 47.2949 12.8684C47.2949 15.1634 49.2641 17.0239 51.6932 17.0239Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1395_10005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 265,
    height: 187,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfound);
export default __webpack_public_path__ + "static/media/notfound.ef183f428270b4e63cf681bc92710b9d.svg";
export { ForwardRef as ReactComponent };